import "./ChangePassword.css";
import { useEffect, useState } from "react";
import { FaCheck, FaLock } from "react-icons/fa";
import { doPost } from "../../../utils/HTTPRequests";
import toast from "react-hot-toast";
import { globals } from "../../../utils/Globals";
import { handleToastPromiseError, initFooterBtns } from "../../../utils/utilsFuncs";
import { validate } from "../../../utils/FormValidation";
import { IoClose } from "react-icons/io5";

function ChangePassword({
  username,
  userId,
  setShowChangePassword,
  isTempPassword,
  currentTempPassword,
  afterChangePassword,
}) {
  const MIN_PASSWORD_LENGTH = 8;
  const MAX_PASSWORD_LENGTH = 20;

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isPasswordContainsLowerCase, setIsPasswordContainsLowerCase] = useState(false);
  const [isPasswordContainsUpperCase, setIsPasswordContainsUpperCase] = useState(false);
  const [isPasswordContainsNumber, setIsPasswordContainsNumber] = useState(false);
  const [isPasswordContainsSpecialCharacter, setIsPasswordContainsSpecialCharacter] = useState(false);
  const [isPasswordLengthMin, setIsPasswordLengthMin] = useState(false);
  const [isPasswordLengthMax, setIsPasswordLengthMax] = useState(true);

  const handlePasswordRequirements = (val) => {
    if (/[a-z]/.test(val)) setIsPasswordContainsLowerCase(true);
    else setIsPasswordContainsLowerCase(false);
    if (/[A-Z]/.test(val)) setIsPasswordContainsUpperCase(true);
    else setIsPasswordContainsUpperCase(false);
    if (/[0-9]/.test(val)) setIsPasswordContainsNumber(true);
    else setIsPasswordContainsNumber(false);
    if (/[@$!%*?&^#+-]/.test(val)) setIsPasswordContainsSpecialCharacter(true);
    else setIsPasswordContainsSpecialCharacter(false);
    if (val.length > MIN_PASSWORD_LENGTH - 1) setIsPasswordLengthMin(true);
    else setIsPasswordLengthMin(false);
    if (val.length < MAX_PASSWORD_LENGTH + 1) setIsPasswordLengthMax(true);
    else setIsPasswordLengthMax(false);
  };

  const rules = {
    currentPassword: {
      object: currentPassword,
      messageName: "Current password",
      required: !isTempPassword,
    },
    newPassword: {
      object: newPassword,
      messageName: "New password",
      required: true,
      minLength: MIN_PASSWORD_LENGTH,
      maxLength: MAX_PASSWORD_LENGTH,
      password: true,
    },
    confirmNewPassword: {
      object: confirmNewPassword,
      messageName: "Confirm new password",
      required: true,
      minLength: MIN_PASSWORD_LENGTH,
      maxLength: MAX_PASSWORD_LENGTH,
      password: true,
    },
  };

  const updatePassword = async () => {
    if (newPassword !== confirmNewPassword) {
      toast.error("passwords don't match");
      throw new Error("passwords don't match");
    }

    if (validate(rules)) {
      toast.promise(
        doPost(
          isTempPassword ? globals.accountHandler.changeTempPassword : globals.accountHandler.changePassword,
          {
            username: username,
            userId: userId,
            newPassword: newPassword,
            oldPassword: currentTempPassword !== undefined ? currentTempPassword : currentPassword,
          },
          true,
        ).then(() => {
          if (afterChangePassword !== undefined) afterChangePassword();
        }),
        {
          loading: "Saving...",
          success: <b>Password Saved!</b>,
          error: (err) => {
            return handleToastPromiseError(err);
          },
        },
      );
    } else {
      throw new Error("validation failed");
    }
  };

  useEffect(() => {
    initFooterBtns("modal-footer-ChangePassword", ["change-password-save-changes"]);
  }, []);
  return (
    <>
      <button
        id="change-password-save-changes"
        style={{ display: "none" }}
        className="footer-save-changes-modal-btn"
        onClick={() => {
          updatePassword()
            .then(() => {
              setShowChangePassword(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      >
        Save Changes
      </button>
      <form className="change-password-form">
        {!isTempPassword && (
          <div className="modal-input-container">
            <input
              name="current-password"
              className="modal-input"
              type="password"
              placeholder="Current Password"
              required
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
            <FaLock className="modal-input-icon" />
          </div>
        )}
        <div className="modal-input-container">
          <input
            name="new-password"
            className="modal-input"
            type="password"
            placeholder="New Password"
            minLength={MIN_PASSWORD_LENGTH}
            required
            maxLength={MAX_PASSWORD_LENGTH}
            onChange={(e) => {
              handlePasswordRequirements(e.target.value);
              setNewPassword(e.target.value);
            }}
          />
          <FaLock className="modal-input-icon" />
        </div>
        <div className="modal-input-container">
          <input
            name="confirm-new-password"
            className="modal-input"
            type="password"
            placeholder="Confirm New Password"
            required
            maxLength={MAX_PASSWORD_LENGTH}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
          <FaLock className="modal-input-icon" />
        </div>
        <div className="change-password-password-requirements">
          <div style={{ marginBottom: "0.3em", fontSize: "1rem", fontWeight: 600 }}>Password requirements:</div>
          <div style={{ color: isPasswordContainsLowerCase ? "green" : "red" }}>
            {isPasswordContainsLowerCase ? <FaCheck /> : <IoClose />} At least one lower case letter [a-z]
          </div>
          <div style={{ color: isPasswordContainsUpperCase ? "green" : "red" }}>
            {isPasswordContainsUpperCase ? <FaCheck /> : <IoClose />} At least one upper case letter [A-Z]
          </div>
          <div style={{ color: isPasswordContainsNumber ? "green" : "red" }}>
            {isPasswordContainsNumber ? <FaCheck /> : <IoClose />} At least one numeral [0-9]
          </div>
          <div style={{ color: isPasswordContainsSpecialCharacter ? "green" : "red" }}>
            {isPasswordContainsSpecialCharacter ? <FaCheck /> : <IoClose />} At least one symbol [@$!%*?&^#+-]
          </div>
          <div style={{ color: isPasswordLengthMin ? "green" : "red" }}>
            {isPasswordLengthMin ? <FaCheck /> : <IoClose />} Minimum 8 characters
          </div>
          <div style={{ color: isPasswordLengthMax ? "green" : "red" }}>
            {isPasswordLengthMax ? <FaCheck /> : <IoClose />} Maximum 20 characters
          </div>
        </div>
      </form>
    </>
  );
}

export default ChangePassword;
